'use strict';

import {isMobile} from "../../../settings";
import {BaseElement} from "../../interfaces/BaseElement";

export function addPoweredLogo (container) {
  const {active} = config.features.bmbyLogo;
  if (!active)
    return;

  const parent = container ? container :
    isMobile
      ? document.querySelector('.aside__top__container')
      : document.querySelector('.aside__bottom__container');

  new BaseElement()
      .addClass('powered__logo')
      .appendTo(parent);
}
